module.exports = __webpack_public_path__ + "static/media/slider-miilb.f7db1ff2.jpg";